import React from "react";
import { Tabs } from "antd";
import { graphql, StaticQuery } from "gatsby";
import Layout from "../../components/TheLayout";
import PublicationsList from "../../components/PublicationsList";
const TabPane = Tabs.TabPane;

const PublicationsPage = () => {
  return (
    <Layout>
      <div
        style={{
          maxWidth: "80%",
          margin: "20px auto",
          textAlign: "center"
        }}
      >
        <h1 style={{ color: "#474487" }}>All Publications</h1>
      </div>
      <StaticQuery
        query={graphql`
          query {
            allMarkdownRemark(
              filter: {
                frontmatter: { templateKey: { eq: "all-publications" } }
              }
              sort: { fields: frontmatter___title, order: DESC }
            ) {
              edges {
                node {
                  frontmatter {
                    title
                    publications {
                      authors
                      journal
                      link
                      title
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const { edges: years } = data.allMarkdownRemark;
          console.log(years);
          return (
            <Tabs
              style={{
                maxWidth: "1140px",
                margin: "16px auto",
                padding: "12px"
              }}
            >
              {years.map((year, index) => (
                <TabPane tab={year.node.frontmatter.title} key={index}>
                  <PublicationsList
                    publications={year.node.frontmatter.publications}
                  />
                </TabPane>
              ))}
            </Tabs>
          );
        }}
      />
    </Layout>
  );
};

export default PublicationsPage;
